import { OrderListTotals } from '../../hooks/useOrderTotals/order-totals.types';

export const combineTotals = (
  onlineData: OrderListTotals[] = [],
  offlineData: OrderListTotals[] = [],
) => {
  return [...onlineData, ...offlineData];
};
